import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const Button = styled.button`
  width: 100%;
  height: 48px;
  border-radius: ${p => p.theme.radius};
  border: none;
  font-family: ${p => p.theme.fontFamily};
  font-size: 15px;
  font-weight: 500;
  cursor: ${p => (p.disabled ? 'default' : 'pointer')};
  transition: opacity 0.15s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  background: ${p =>
    p.variant === 'secondary' ? 'var(--tz-hairline, rgba(255, 255, 255, 0.08))'
    : p.disabled ? p.theme.disabledBg
    : p.theme.accent};
  color: ${p =>
    p.disabled ? p.theme.textTertiary : p.theme.accentText};
  opacity: ${p => (p.disabled ? 0.6 : 1)};

  &:hover:not(:disabled) {
    opacity: 0.85;
  }

  &:active:not(:disabled) {
    opacity: 0.75;
  }
`;

// Theme-aware: while loading the button renders its DISABLED background
// (disabledBg — pale gray under light side-app branding), so a hardcoded
// white spinner was invisible on light flows (BH/Rivian). Track the theme's
// text color: near-black on light branding, white on dark.
const Spinner = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid ${p => p.theme.border};
  border-top-color: ${p => p.theme.text};
  border-radius: 50%;
  animation: ${spin} 0.6s linear infinite;
`;

export default function OAuthButton({ children, loading, disabled, variant, onClick, type = 'button' }) {
  return (
    <Button
      type={type}
      disabled={disabled || loading}
      variant={variant}
      onClick={onClick}
    >
      {loading ? <Spinner /> : children}
    </Button>
  );
}
